import { faAdd, faFilter } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { motion } from "framer-motion"

interface FilterButtonsProps {
    handleClick: () => void,
    title: string
}

const FilterButton = ({ handleClick, title }: FilterButtonsProps) => {
    return (
        <motion.button
            // whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            // onClick={() => setIsFilterOpened(!isFilterOpened)}
            onClick={handleClick}
            className="relative px-4 py-2 bg-indigo-100 dark:bg-indigo-900/20 text-indigo-700 dark:text-indigo-400 rounded-lg hover:bg-indigo-200 dark:hover:bg-indigo-800/40 transition-colors duration-200 flex items-center"
        >
            <FontAwesomeIcon icon={faAdd} className="mr-1.5" />
            <span>{title}</span>
            {/* {filterChips.length > 0 && (
            <span className="absolute -top-1.5 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-blue-600 text-[10px] text-white font-bold">
                {filterChips.length}
            </span>
        )} */}
        </motion.button>
    )
}
export default FilterButton